import Backbone from 'backbone';
import Model from './InterfaceParameterModel';
import Globals from '../../../utils/Globals';

const Collection = Backbone.Collection.extend({
    url: () => Globals.baseUrl + 'interfaces/config',
    model: Model,
});
export default Collection;
